import { onMounted, onBeforeUnmount } from 'vue';

/** Calls `callback` once, the first time the `el` template ref comes into view. */
export function useFirstVisible(el, callback) {
    let observer = null;

    onMounted(() => {
        observer = new IntersectionObserver(([entry]) => {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            callback();
        });
        observer.observe(el.value);
    });
    onBeforeUnmount(() => observer.disconnect());
}
